import { UserIcon, CalendarIcon, LockClosedIcon, ArrowPathIcon, CreditCardIcon, TruckIcon, WalletIcon, BanknotesIcon } from "@heroicons/react/24/solid";

const CreditCardPayment = ({ nameCard, setNameCard, cardnumber, setCardnumber, exp_date, setExp_date, cvv, setCvv, btnLoading, orders, t }) => {
  const handleCardNumberChange = (e) => {
    let value = e.target.value.replace(/\D/g, '');
    if (value.length > 4) value = value.replace(/(\d{4})(?=\d)/g, '$1-');
    setCardnumber(value);
  };

  const handleExpDateChange = (e) => {
    let value = e.target.value.replace(/\D/g, '').slice(0, 4);
    if (value.length > 2 && parseInt(value.slice(0, 2)) > 12) value = `12${value.slice(2)}`;
    setExp_date(value.length > 2 ? `${value.slice(0, 2)}/${value.slice(2)}` : value);
  };  

  const handleCvvChange = (e) => {
    let value = e.target.value.replace(/\D/g, '');
    setCvv(value.slice(0, 3));
  };

  return (
    <div className="mt-4 space-y-3">
      <div className="bg-white p-6 rounded-lg border border-gray-200">
        <div className="flex items-center gap-3 mb-4">
          <CreditCardIcon className="w-6 h-6 text-indigo-600" />
          <span className="font-medium text-lg">{t("co-credit-card")}</span>
        </div>

        <div className="">
          <div className="grid grid-cols-2 gap-4">
            <div className="relative">
              <label htmlFor="name-card" className="block text-sm font-medium text-gray-700">
                {t("name-card")} <span className="text-red-500">*</span>
              </label>
              <div className="mt-1 relative rounded-md shadow-sm">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <UserIcon className="h-5 w-5 text-gray-400" />
                </div>
                <input type="text" id="name-card" value={nameCard} onChange={(e) => setNameCard(e.target.value)} placeholder={t("ur-name-card")}
                  className="pl-10 block w-full rounded-md border border-gray-300 bg-gray-50 focus:ring-indigo-500 focus:border-indigo-500 p-2.5 text-sm" required />
              </div>
            </div>

            <div className="relative">
              <label htmlFor="cardnumber" className="block text-sm font-medium text-gray-700">
                {t("cardnumber")} <span className="text-red-500">*</span>
              </label>
              <div className="mt-1 relative rounded-md shadow-sm">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <CreditCardIcon className="h-5 w-5 text-gray-400" />
                </div>
                <input type="text" id="cardnumber" name="card-number" value={cardnumber} onChange={handleCardNumberChange} placeholder="xxxx-xxxx-xxxx-xxxx"
                  className="pl-10 block w-full rounded-md border border-gray-300 bg-gray-50 focus:ring-indigo-500 focus:border-indigo-500 p-2.5 text-sm" required />
              </div>
            </div>


            <div className="relative">
              <label htmlFor="cardexpiration" className="block text-sm font-medium text-gray-700">
                {t("expirationdate")} <span className="text-red-500">*</span>
              </label>
              <div className="mt-1 relative rounded-md shadow-sm">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <CalendarIcon className="h-5 w-5 text-gray-400" />
                </div>
                <input type="text" id="cardexpiration" value={exp_date} onChange={handleExpDateChange} placeholder="MM/YY"
                  className="pl-10 block w-full rounded-md border border-gray-300 bg-gray-50 focus:ring-indigo-500 focus:border-indigo-500 p-2.5 text-sm" required />
              </div>
            </div>

            <div className="relative">
              <label htmlFor="cvv" className="block text-sm font-medium text-gray-700">
                Cvv <span className="text-red-500">*</span>
              </label>
              <div className="mt-1 relative rounded-md shadow-sm">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <LockClosedIcon className="h-5 w-5 text-gray-400" />
                </div>
                <input type="text" id="cvv" value={cvv} onChange={handleCvvChange}
                  className="pl-10 block w-full rounded-md border border-gray-300 bg-gray-50 focus:ring-indigo-500 focus:border-indigo-500 p-2.5 text-sm" placeholder="***" required />
              </div>
            </div>
          </div>

          <div className="pt-4">
            <button type="submit" disabled={orders.length <= 0 || btnLoading} className="w-full flex items-center justify-center px-4 py-3 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:bg-indigo-300 disabled:cursor-not-allowed transition-colors duration-200">
              {btnLoading ? (
                <span className="flex items-center gap-2">
                  <ArrowPathIcon className="animate-spin h-5 w-5" />
                  {t("processing")}
                </span>
              ) : (
                <>
                  <CreditCardIcon className="h-5 w-5 mr-2" />
                  {t("pay")}
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const PaypalPayment = ({ t }) => (
  <div className="mt-4 space-y-3">
    <div className="bg-white p-4 rounded-lg border border-gray-200">
      <div className="flex items-center gap-3 mb-3">
        <WalletIcon className="w-5 h-5 text-blue-600" />
        <span className="font-medium">{t("pay-paypal")}</span>
      </div>
      <p className="text-sm text-gray-600 mb-4">
        {t("pay-paypal-text")}
      </p>
      <button type="button" className="text-sm w-full bg-[#0070BA] hover:bg-[#003087] transition-colors duration-200 text-white font-medium py-3 px-4 rounded-lg flex items-center justify-center gap-2">
        <img src="https://cdnjs.cloudflare.com/ajax/libs/simple-icons/11.3.0/paypal.svg" alt="PayPal" className="w-4 h-4 invert" />
        {t("pay-paypal")}
      </button>
    </div>
  </div>
);

const CashOnDeliveryPayment = ({ btnLoading, orders, t }) => (
  <div className="mt-4 space-y-3">
    <div className="bg-white p-4 rounded-lg border border-gray-200">
      <div className="flex items-center gap-3 mb-3">
        <TruckIcon className="w-5 h-5 text-green-600" />
        <span className="font-medium">{t("cash-delivery")}</span>
      </div>
      <div className="space-y-3">
        <p className="text-sm text-gray-600">
          {t("cash-delivery-text-1")}
        </p>
        <ul className="text-sm text-gray-600 space-y-1">
          <li className="flex items-center gap-2">
            <div className="w-1 h-1 rounded-full bg-gray-400"></div>
            {t("cash-delivery-text-2")}
          </li>
          <li className="flex items-center gap-2">
            <div className="w-1 h-1 rounded-full bg-gray-400"></div>
            {t("cash-delivery-text-3")}
          </li>
        </ul>
      </div>
      <button type="submit" disabled={orders.length <= 0 || btnLoading}
        className="text-sm w-full mt-4 bg-green-600 hover:bg-green-700 disabled:bg-green-300 disabled:cursor-not-allowed transition-colors duration-200 text-white font-medium py-3 px-4 rounded-lg flex items-center justify-center gap-2">
        {btnLoading ? (
          <span className="flex items-center gap-2">
            <ArrowPathIcon className="animate-spin h-5 w-5" />
            {t("processing")}
          </span>
        ) : (
          <>
            <BanknotesIcon className="size-5" />
            {t("pay-delivery")}
          </>
        )}
      </button>
    </div>
  </div>
);

export {
  CreditCardPayment,
  CashOnDeliveryPayment,
  PaypalPayment,
};